var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful/cta-button-helpers.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
var macro_t_1 = runtime.makeMacro(
[], 
["CTAButtonsFullWidthField"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("CTAButtonsFullWidthField", kwargs.hasOwnProperty("CTAButtonsFullWidthField") ? kwargs["CTAButtonsFullWidthField"] : "none");
var t_2 = "";var t_3;
t_3 = env.getFilter("lower").call(context, runtime.contextOrFrameLookup(context, frame, "CTAButtonsFullWidthField"));
frame.set("cleanFullWidthField", t_3, true);
if(frame.topLevel) {
context.setVariable("cleanFullWidthField", t_3);
}
if(frame.topLevel) {
context.addExport("cleanFullWidthField", t_3);
}
t_2 += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "cleanFullWidthField") == "mobile only") {
t_2 += "\n\n        c-cta-button--full-width-buttons-small\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "cleanFullWidthField") == "large only") {
t_2 += "\n\n        c-cta-button--full-width-buttons-large\n\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "cleanFullWidthField") == "all devices") {
t_2 += "\n\n        c-cta-button--full-width-buttons-all\n\n    ";
;
}
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("buildCTAFullWidthClass");
context.setVariable("buildCTAFullWidthClass", macro_t_1);
output += "\n\n";
output += "\n";
output += "\n";
var macro_t_4 = runtime.makeMacro(
["bottomAlignCTAs", "CTAButtonsFullWidthField"], 
[], 
function (l_bottomAlignCTAs, l_CTAButtonsFullWidthField, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("bottomAlignCTAs", l_bottomAlignCTAs);
frame.set("CTAButtonsFullWidthField", l_CTAButtonsFullWidthField);
var t_5 = "";var t_6;
t_6 = env.getFilter("lower").call(context, l_CTAButtonsFullWidthField);
frame.set("cleanFullWidthField", t_6, true);
if(frame.topLevel) {
context.setVariable("cleanFullWidthField", t_6);
}
if(frame.topLevel) {
context.addExport("cleanFullWidthField", t_6);
}
t_5 += "\n\n    ";
if(l_bottomAlignCTAs) {
t_5 += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "cleanFullWidthField") == "mobile only") {
t_5 += "\n\n            s-text-over-image__bottom-ctas-full-width-mobile\n\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "cleanFullWidthField") == "large only") {
t_5 += "\n\n            s-text-over-image__bottom-ctas-full-width-large\n\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "cleanFullWidthField") == "all devices") {
t_5 += "\n\n            s-text-over-image__bottom-ctas-full-width-all\n\n        ";
;
}
else {
t_5 += "\n\n            s-text-over-image__bottom-ctas\n\n        ";
;
}
;
}
;
}
t_5 += "\n\n    ";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_5);
});
context.addExport("buildBottomAlignScopeClass");
context.setVariable("buildBottomAlignScopeClass", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful/cta-button-helpers.j2"] , dependencies)